import React from 'react';
import "./Follow.css"

const Follow = () => {
    return (
        <div style={{backgroundColor: "black"}} className='text-center bg-img p-4'>
            <h3 className="text-light">FOLLOW US ON INSTAGRAM</h3>
            <h4 style={{color: "coral"}} ><strong>@HomeDecor0</strong></h4>
        </div>
    );
};

export default Follow;